export { default as Banner } from './Banner.vue';
